export const FILE_MAX_SIZE: number = 20 * 1024 * 1024;
export const FILE_MAX_SIZE_MESSAGE: string = `Максимальный размер файла не должен превышать 20mb`;
export const CHAT_NAME_MAX_LENGTH: number = 50;
export const CLIENT_NAME_MAX_LENGTH: number = 30;
export const COMMENT_MAX_LENGTH: number = 50000;